(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/root-view.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/root-view.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.RootView = Backbone.Marionette.View.extend({
    el: '#main-content',
    regions: {
      mainArea: '#tipset-root'
    }
  });
})(Backbone, _, svs);

 })(window);